"use client";

import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";


const NEXT_PUBLIC_FRESHDESK_URL="https://growthschool.freshdesk.com"

// PhoneInputComponent import would be adjusted based on your file structure
const PhoneInputComponent = ({ phone, setphone }) => {
  return (
    <div className="relative flex border border-gray-300 rounded-lg overflow-hidden">
      {/* <Image
        src="/india-flag.svg"
        alt="India flag"
        width={24}
        height={20}
        className="h-5 w-6 mr-1"
      />

      <span className="text-gray-700">+91</span> */}

      <input
        type="tel"
        value={phone}
        onChange={(e) => setphone(e.target.value)}
        placeholder="Enter phone number"
        className="flex-grow py-3 px-4 w-full border"
      />
    </div>
  );
};

export default function ContactUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [apiError, setApiError] = useState(false);
  const [successState, setSuccessState] = useState(false);

  const handlePhoneChange = (value) => {
    if (!value) {
      setPhone(value);
      setPhoneError("Please enter your phone number");
    } else if (value.length < 10) {
      setPhoneError("Please enter a valid phone number");
    } else {
      setPhoneError("");
    }
    setPhone(value);
  };

  const handleNameChange = (e) => {
    const { value } = e.target;
    if (!value.trim()) {
      setNameError("Please enter your name");
    } else {
      setNameError("");
    }
    setName(value);
  };

  const handleEmailChange = (e) => {
    const { value } = e.target;
    if (!value.trim()) {
      setEmailError("Please enter your email address");
    } else if (
      !String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
    setEmail(value);
  };

  const handleMessageChange = (e) => {
    const { value } = e.target;
    setMessage(value);
  };

  const handleSubmit = () => {
    let isValid = true;

    if (!name.trim()) {
      setNameError("Please enter your name");
      isValid = false;
    }

    if (!email.trim()) {
      setEmailError("Please enter your email address");
      isValid = false;
    } else if (
      !String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      setEmailError("Please enter a valid email address");
      isValid = false;
    }

    if (!phone) {
      setPhoneError("Please enter your phone number");
      isValid = false;
    } else if (phone.length < 10) {
      setPhoneError("Please enter a valid phone number");
      isValid = false;
    }

    if (isValid) {
      fetch("https://growthschool.freshdesk.com/api/v2/tickets", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${btoa(
            `${process.env.NEXT_PUBLIC_FRESHDESK_API_KEY}:X`
          )}`,
        },
        body: JSON.stringify({
          description: `Message: ${message}\nPhone Number: ${phone}`,
          subject: `New ticket from ${name}`,
          email: email,
          priority: 1,
          status: 2,
          type: "Request",
          cc_emails: ["hi@growthschool.io"],
          custom_fields: {
            cf_update_tag: true,
            cf_origin: "International",
          },
          responder_id: 1070011619476,
        }),
      })
        .then((response) => {
          setSuccessState(true);
        })
        .catch((error) => {
          setApiError(true);
        });
    }
  };

  return (
    <div className="w-full py-10 mt-20">
      <div className="w-[90%] md:w-[70%] mx-auto">
        <div className="flex items-center gap-2 mb-6">
          <Link href="/" className="text-[#686C7A]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
            >
              <path
                d="M10.4722 2.128C10.1942 1.91179 9.85214 1.7944 9.5 1.7944C9.14787 1.7944 8.80578 1.91179 8.52783 2.128L1.8905 7.28967C1.29517 7.75438 1.62292 8.70834 2.37738 8.70834H3.16667V15.0417C3.16667 15.4616 3.33348 15.8643 3.63041 16.1613C3.92735 16.4582 4.33007 16.625 4.75 16.625H7.91667V11.875C7.91667 11.4551 8.08348 11.0523 8.38042 10.7554C8.67735 10.4585 9.08007 10.2917 9.5 10.2917C9.91993 10.2917 10.3227 10.4585 10.6196 10.7554C10.9165 11.0523 11.0833 11.4551 11.0833 11.875V16.625H14.25C14.6699 16.625 15.0727 16.4582 15.3696 16.1613C15.6665 15.8643 15.8333 15.4616 15.8333 15.0417V8.70834H16.6226C17.3763 8.70834 17.7056 7.75438 17.1095 7.29046L10.4722 2.128Z"
                fill="#686C7A"
              />
            </svg>
          </Link>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="9"
            viewBox="0 0 6 9"
            fill="none"
          >
            <path
              opacity="0.6"
              d="M1 0.5L5 4.5L1 8.5"
              stroke="#686C7A"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="text-[#686C7A] text-sm">Contact Us</span>
        </div>

        <div className="bg-[#FFFAF1] rounded-xl p-8 md:p-12 border border-black/60 " >
          <div className="flex flex-col md:flex-row md:space-x-12">
            {/* Left side - Contact info */}
            <div className="md:w-2/3 mb-8 md:mb-0">
              <h1 className="text-[32px] font-medium text-[#002726] mb-4">
                Contact Us
              </h1>
              <div>
                <p className="text-base md:text-[16px] text-[#002726] leading-relaxed mb-1">
                  For any support, please mail to hi@growthschool.io.
                </p>
                <p className="text-base md:text-[16px] text-[#002726] leading-relaxed">
                  Our Support team will get back to you within 24 hours.
                </p>
              </div>
            </div>

            {/* Right side - Form */}
            <div className="md:w-1/3">
              {successState ? (
                <div className="bg-green-50 p-4 rounded-lg">
                  <p className="text-sm leading-6 text-[#001A19]">
                    Thanks for getting in touch! We&apos;ve got your request and
                    we&apos;re on it. Someone from our team will be reaching out to
                    you shortly.
                  </p>
                </div>
              ) : (
                <div className="space-y-6">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-[#002726] mb-2"
                    >
                      Full Name<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      placeholder="Full Name"
                      value={name}
                      onChange={handleNameChange}
                      className={`w-full px-4 py-3 rounded-lg border ${
                        nameError ? "border-red-500" : "border-black"
                      } focus:outline-none focus:ring-1 focus:ring-gray-400 bg-trasparent`}
                    />
                    {nameError && (
                      <p className="mt-1 text-xs text-red-600">{nameError}</p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-[#002726] mb-2"
                    >
                      Email Address<span className="text-red-500 ml-1">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      placeholder="Email"
                      value={email}
                      onChange={handleEmailChange}
                      className={`w-full px-4 py-3 rounded-lg border ${
                        emailError ? "border-red-500" : "border-black"
                      } focus:outline-none focus:ring-1 focus:ring-gray-400 bg-transparent`}
                    />
                    {emailError && (
                      <p className="mt-1 text-xs text-red-600">{emailError}</p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-[#002726] mb-2"
                    >
                      Phone Number<span className="text-red-500 ml-1">*</span>
                    </label>
                    <PhoneInputComponent
                      phone={phone}
                      setphone={handlePhoneChange}
                    />
                    {phoneError && (
                      <p className="mt-1 text-xs text-red-600">{phoneError}</p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-[#002726] mb-2"
                    >
                      Message
                    </label>
                    <textarea
                      id="message"
                      placeholder="Have a question about a specific course? Make sure you mention the name."
                      rows={6}
                      value={message}
                      onChange={handleMessageChange}
                      className="w-full px-4 py-3 rounded-lg border border-black focus:outline-none focus:ring-1 focus:ring-gray-400 bg-transparent"
                    ></textarea>
                  </div>

                  <div>
                    <button
                      onClick={handleSubmit}
                      className="w-full bg-white hover:text-white border hover:bg-[#002726] text-black font-medium py-3 px-6 rounded-lg transition-colors"
                    >
                      Submit
                    </button>
                  </div>

                  {apiError && (
                    <p className="text-xs text-red-600 text-center">
                      Oops! Something went wrong. Try again.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
